import { axios, axios2 } from '@/lib/axios';

export const postSubscriptionBasic = (id: any) => {
  const payload = {
    subscription_id: id,
  };
  return axios2.post('/subscription-api/buy-basic-user-plan', payload);
};

export const postSubscriptionBasiclawyer = (id: any) => {
  const payload = {
    subscription_id: id,
  };
  return axios2.post('/subscription-api/buy-basic-lawyer-plan', payload);
};

export const postSubscriptionBasicAgency = (id: any) => {
  const payload = {
    subscription_id: id,
  };
  return axios2.post('/subscription-api/buy-basic-agency-plan', payload);
};
